import { supabase } from '../../adapters/database/supabaseClient'

export type NexiManualKind = 'cashier' | 'operator'
export type NexiPosPending={eventId:string;paymentId:string;orderNumber:number;amountCents:number;sessionToken:string;kind:NexiManualKind;returnPath:string}
const POS_KEY='event-platform:nexi-pos-pending'
export const getPendingNexiPos=():NexiPosPending|null=>{try{const v=sessionStorage.getItem(POS_KEY);return v?JSON.parse(v):null}catch{return null}}
export const savePendingNexiPos=(p:NexiPosPending)=>sessionStorage.setItem(POS_KEY,JSON.stringify(p))
export const clearPendingNexiPos=()=>sessionStorage.removeItem(POS_KEY)

export async function prepareNexiManual(input:{eventId:string;orderId?:string;paymentId?:string;sessionToken:string;kind:NexiManualKind}) {
  const { data,error }=await supabase.rpc('prepare_nexi_manual_payment',{
    target_event_id:input.eventId,target_order_id:input.orderId??null,target_payment_id:input.paymentId??null,
    target_session_token:input.sessionToken,target_kind:input.kind
  })
  if(error)throw error
  return data as {paymentId:string;orderId:string;amountCents:number;callerTrxId:string}
}

export async function confirmNexiManual(input:{eventId:string;paymentId:string;sessionToken:string;kind:NexiManualKind}) {
  const {data,error}=await supabase.rpc('confirm_nexi_manual_payment',{
    target_event_id:input.eventId,target_payment_id:input.paymentId,target_session_token:input.sessionToken,target_kind:input.kind
  })
  if(error)throw error
  return data as {ok:boolean;orderId:string}
}



export type NexiStaffPaymentStatus={
  ok:boolean;paid:boolean;resolved:boolean;orderId:string;orderNumber:number;
  amountCents:number;paymentStatus:string;orderStatus:string;provider:string
}
export async function getNexiStaffPaymentStatus(input:{
  eventId:string;paymentId:string;sessionToken:string;kind:NexiManualKind
}):Promise<NexiStaffPaymentStatus>{
  const {data,error}=await supabase.rpc('nexi_staff_payment_status',{
    target_event_id:input.eventId,target_payment_id:input.paymentId,
    target_session_token:input.sessionToken,target_kind:input.kind
  })
  if(error)throw error
  return data as NexiStaffPaymentStatus
}

export function launchNexiPosPayment(input:{amountCents:number;callerTrxId:string;callerName?:string;returnUri?:string}) {
  const params=new URLSearchParams({
    amount:String(Math.max(1,Math.round(input.amountCents))),
    callerTrxId:input.callerTrxId.slice(0,30),
    callerName:(input.callerName||'Event Platform').slice(0,30),
    sendTicket:'false',
    urlTicket:'false',
    autoClose:'true',
    hideRetry:'false',
    uri:input.returnUri||`${window.location.origin}${window.location.pathname}?nexi_pos_return=1`
  })
  window.location.href='neximpos://payment?'+params.toString()
}
